import { UpperCasePipe } from '@angular/common';
import {
	Component,
	ChangeDetectionStrategy,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
import { DaysOfWeekType } from '@app/pages/cmms/interfaces/scheduled-value.interface';
import { NgxTolgeeModule } from '@tolgee/ngx';
@Component({
	selector: 'weeks-period-content',
	templateUrl: './weeks-period-content.component.html',
	styleUrls: ['./weeks-period-content.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [UpperCasePipe, NgxTolgeeModule],
})
export class WeeksPeriodContentComponent {
	@Input() set selectedDays(selectedDays: DaysOfWeekType[]) {
		this.selectedDaysSet = new Set<DaysOfWeekType>(selectedDays);
	}

	@Input() selectedDaysError: boolean;

	@Output() valuesChanged = new EventEmitter<DaysOfWeekType[]>();

	nameOfTheDay: DaysOfWeekType[] = [
		'monday',
		'tuesday',
		'wednesday',
		'thursday',
		'friday',
		'saturday',
		'sunday',
	];

	selectedDaysSet = new Set<DaysOfWeekType>();

	toggleDaySelection(day: DaysOfWeekType): void {
		if (this.isDaySelected(day)) {
			this.selectedDaysSet.delete(day);
		} else {
			this.selectedDaysSet.add(day);
		}

		this.valuesChanged.emit(Array.from(this.selectedDaysSet));
	}

	isDaySelected(day: DaysOfWeekType): boolean {
		return this.selectedDaysSet.has(day);
	}
}
